/* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import GestureHandler from "./GestureHandler";
import { PixelRatio } from "react-native";
var DraggingGestureHandler = /*#__PURE__*/ function(GestureHandler) {
    "use strict";
    _inherits(DraggingGestureHandler, GestureHandler);
    var _super = _create_super(DraggingGestureHandler);
    function DraggingGestureHandler() {
        _class_call_check(this, DraggingGestureHandler);
        return _super.apply(this, arguments);
    }
    _create_class(DraggingGestureHandler, [
        {
            key: "shouldEnableGestureOnSetup",
            get: function get() {
                return true;
            }
        },
        {
            key: "transformNativeEvent",
            value: function transformNativeEvent(param) {
                var deltaX = param.deltaX, deltaY = param.deltaY, velocityX = param.velocityX, velocityY = param.velocityY, _param_center = param.center, x = _param_center.x, y = _param_center.y;
                // @ts-ignore FIXME(TS)
                var rect = this.view.getBoundingClientRect();
                var ratio = PixelRatio.get();
                return {
                    translationX: deltaX - (this.__initialX || 0),
                    translationY: deltaY - (this.__initialY || 0),
                    absoluteX: x,
                    absoluteY: y,
                    velocityX: velocityX * ratio,
                    velocityY: velocityY * ratio,
                    x: x - rect.left,
                    y: y - rect.top
                };
            }
        }
    ]);
    return DraggingGestureHandler;
}(GestureHandler);
export default DraggingGestureHandler;
